<template>
<ItpBox
  direction="column"
>
  <ItpBox
    direction="column"
    v-if="items && items.length"
  >
    <ItpBox
      :key="item.id"
      alignItems="center"
      class="border rounded rounded-lg p-2 mb-2 overflow-hidden"
      v-for="item in items"
    >
      <UcFileIcon
        size="small"
        :filename="item.file_name"
        class="mr-2"
      >
      </UcFileIcon>
      <ItpLink
        :text="item.file_name"
        :href="item.download_url"
        :tooltip="item.file_name"
        :downloadFileName="item.file_name"
        download-link-only
        use-auth
      >
      </ItpLink>
      <b-dropdown
        boundary="viewport"
        size="sm"
        toggle-class="btn-default-borderless"
        no-caret
        variant="none"
        dropleft
        class="ml-auto mb-auto"
        v-if="!item.locked"
      >
        <ItpIcon
          fa="ellipsis-v"
          class="mx-1"
          slot="button-content"
        >
        </ItpIcon>
        <b-dropdown-item-button
          @click.prevent.stop="evh_5382094220310827_clickPreventStop($event, {item})"
        >
          <ItpText
            :text="'Edit'|pgettext('Command')"
          >
          </ItpText>
        </b-dropdown-item-button>
        <b-dropdown-item-button
          @click.prevent.stop="evh_2688566256707306_clickPreventStop($event, {item})"
        >
          <ItpText
            :text="'Delete'|pgettext('Command')"
          >
          </ItpText>
        </b-dropdown-item-button>
      </b-dropdown>
    </ItpBox>
  </ItpBox>
  <ItpLink
    :icon="$config.addIcon"
    :text="'Upload file...'|pgettext('Attachments')"
    class="ml-auto"
    v-if="!parent.isReadOnly"
    @click.prevent.stop="evh_5962862420439144_clickPreventStop($event, {})"
  >
  </ItpLink>
</ItpBox>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcAttachmentsPanel extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    type: String,
  })
  parent_id!: string;

  @Watch('parent_id')
  onParent_id(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("parent_id")
  }

  @Prop({
    type: Object,
  })
  parent!: object;

  @Watch('parent')
  onParent(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("parent")
  }

  @Prop({
    type: Boolean,
  })
  readonly!: boolean;

  @Watch('readonly')
  onReadonly(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("readonly")
  }

  container!: any;

  async $$load_container() {
    return this.$fn.fetch('list_attachment', { parameters: { 'owner-id': this.parent_id || this.parent.id }, asResourceContainer: true })
  }

  ux!: any;
  dataMembers = ['container', 'ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        container: null,
        ux: null,
      },
    }
  }

  get items() {
    if (this.loaded) {

      return this.container.data
    }
    return null;
  }

  get isReadOnly() {
    if (this.loaded) {

      return this.readonly || (this.parent && this.parent.isReadOnly)
    }
    return null;
  }

  async act_5382094220310827_showModal_2648_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_5382094220310827_showModal_2648, alias=undefined
    return {
      name: "WAttachmentModal",
      props: {
        object_id: this.parent_id || this.parent.id,
        attachment: _.cloneDeep($event.scope.item),
      }
      ,
    }
  }

  async evh_5382094220310827_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5382094220310827_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_2688566256707306_request_2652_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_2688566256707306_request_2652, alias=undefined
    return {
      operation: "delete_attachment",
      data: $event.scope.item,
    }
  }

  async act_2688566256707306_request_2652_getConfirm($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_2688566256707306_request_2652, alias=undefined
    return {
      message: this.$fn.gettext("Please confirm delete."),
      btnOk: this.$fn.gettext("Delete"),
    }
  }

  async evh_2688566256707306_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2688566256707306_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_5962862420439144_showModal_2656_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_5962862420439144_showModal_2656, alias=undefined
    return {
      name: "WAttachmentModal",
      props: {
        object_id: this.parent_id || this.parent.id,
      }
      ,
    }
  }

  async evh_5962862420439144_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5962862420439144_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_5382094220310827_reloadComponentData_2650: actions.ReloadComponentDataAction;
    evh_5382094220310827_close_2649: actions.EventHandlerImpl;
    act_5382094220310827_showModal_2648: actions.ShowModalAction;
    evh_5382094220310827_clickPreventStop_2647: actions.EventHandlerImpl;
    evh_5382094220310827_clickPreventStop: actions.EventHandlerGroup;
    act_2688566256707306_reloadComponentData_2654: actions.ReloadComponentDataAction;
    evh_2688566256707306_success_2653: actions.EventHandlerImpl;
    act_2688566256707306_request_2652: actions.RequestAction;
    evh_2688566256707306_clickPreventStop_2651: actions.EventHandlerImpl;
    evh_2688566256707306_clickPreventStop: actions.EventHandlerGroup;
    act_5962862420439144_reloadComponentData_2658: actions.ReloadComponentDataAction;
    evh_5962862420439144_close_2657: actions.EventHandlerImpl;
    act_5962862420439144_showModal_2656: actions.ShowModalAction;
    evh_5962862420439144_clickPreventStop_2655: actions.EventHandlerImpl;
    evh_5962862420439144_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_5382094220310827_reloadComponentData_2650 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_5382094220310827_close_2649 = new actions.EventHandlerImpl(
      {
        action: act_5382094220310827_reloadComponentData_2650,
        event: "close",
        displayName: "reloadComponentData",
      }
    );
    const act_5382094220310827_showModal_2648 = new actions.ShowModalAction(
      {
        actionArgs: this.act_5382094220310827_showModal_2648_getActionArgs,
        events: [evh_5382094220310827_close_2649],
      }
    );
    const evh_5382094220310827_clickPreventStop_2647 = new actions.EventHandlerImpl(
      {
        action: act_5382094220310827_showModal_2648,
        event: "click.prevent.stop",
        displayName: "showModal",
      }
    );
    const evh_5382094220310827_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_5382094220310827_clickPreventStop_2647],
      }
    );
    const act_2688566256707306_reloadComponentData_2654 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_2688566256707306_success_2653 = new actions.EventHandlerImpl(
      {
        action: act_2688566256707306_reloadComponentData_2654,
        event: "success",
        displayName: "reloadComponentData",
      }
    );
    const act_2688566256707306_request_2652 = new actions.RequestAction(
      {
        actionArgs: this.act_2688566256707306_request_2652_getActionArgs,
        confirm: this.act_2688566256707306_request_2652_getConfirm,
        events: [evh_2688566256707306_success_2653],
      }
    );
    const evh_2688566256707306_clickPreventStop_2651 = new actions.EventHandlerImpl(
      {
        action: act_2688566256707306_request_2652,
        event: "click.prevent.stop",
        displayName: "request",
      }
    );
    const evh_2688566256707306_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_2688566256707306_clickPreventStop_2651],
      }
    );
    const act_5962862420439144_reloadComponentData_2658 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_5962862420439144_close_2657 = new actions.EventHandlerImpl(
      {
        action: act_5962862420439144_reloadComponentData_2658,
        event: "close",
        displayName: "reloadComponentData",
      }
    );
    const act_5962862420439144_showModal_2656 = new actions.ShowModalAction(
      {
        actionArgs: this.act_5962862420439144_showModal_2656_getActionArgs,
        events: [evh_5962862420439144_close_2657],
      }
    );
    const evh_5962862420439144_clickPreventStop_2655 = new actions.EventHandlerImpl(
      {
        action: act_5962862420439144_showModal_2656,
        event: "click.prevent.stop",
        displayName: "showModal",
      }
    );
    const evh_5962862420439144_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_5962862420439144_clickPreventStop_2655],
      }
    );
    return {
      act_5382094220310827_reloadComponentData_2650,
      evh_5382094220310827_close_2649,
      act_5382094220310827_showModal_2648,
      evh_5382094220310827_clickPreventStop_2647,
      evh_5382094220310827_clickPreventStop,
      act_2688566256707306_reloadComponentData_2654,
      evh_2688566256707306_success_2653,
      act_2688566256707306_request_2652,
      evh_2688566256707306_clickPreventStop_2651,
      evh_2688566256707306_clickPreventStop,
      act_5962862420439144_reloadComponentData_2658,
      evh_5962862420439144_close_2657,
      act_5962862420439144_showModal_2656,
      evh_5962862420439144_clickPreventStop_2655,
      evh_5962862420439144_clickPreventStop,
    }
  }
}

Vue.component("UcAttachmentsPanel", UcAttachmentsPanel);

</script>